import type { ReactElement } from "react"
import { PeriodInfo } from "@core/period-info"
import { CURRENCY_SEPARATOR } from "@core/pricing"
import { PriceFormat } from "@core/types"
import type { CloudBluePlan } from "@gatsby-plugin-definitions/fragments/CloudBluePlan"
import Price from "@ionos-web-design-system/react/price"
import { cn } from "~/helpers/cn"
import isEmpty from "~/lib/isEmpty"
import type { CloudBlueDomain } from "../../../../../src/types/squidex"

type ProductPriceProps = {
  plan?: CloudBluePlan[] | CloudBlueDomain[]
  isSmall?: boolean
  hasTextColor?: boolean
  className?: string
}

export default function ProductPrice({
  plan,
  isSmall,
  hasTextColor,
  className,
}: ProductPriceProps): ReactElement<ProductPriceProps> | null {
  if (isEmpty(plan) || isEmpty(plan[0].flatData.periods)) {
    return null
  }

  const defaultPeriod = plan[0].flatData.periods.find(
    (period) => period.default
  )

  if (!defaultPeriod) {
    return null
  }

  const priceInfo = new PeriodInfo(defaultPeriod)
  const suffix = priceInfo.getFormatted(PriceFormat.GROSS_WITH_PERIOD)

  return (
    <Price
      data={{
        main: {
          integerPrice: priceInfo.getFormatted(
            PriceFormat.REGISTER_GROSS_DECIMALS
          ),
          comma: CURRENCY_SEPARATOR,
          decimalPrice: priceInfo.getFormatted(
            PriceFormat.REGISTER_GROSS_CENTS
          ),
          currency: priceInfo.getFormatted(PriceFormat.CURRENCY),
          currencySymbolPosition: "after",
        },
        postlines: suffix ? [{ content: suffix }] : undefined,
      }}
      size={isSmall ? "small" : "medium"}
      emphasis={hasTextColor}
      variant="simple"
      hasNoFixedSizes
      forcePostlineWeight
      className={cn("leading-normal", className)}
    />
  )
}
